import {Injectable} from '@angular/core';

import {forkJoin, Observable} from 'rxjs';

import {ApiService} from '../../shared/api';
import {Image} from '../../shared/files';
import {FileDescription} from '../../shared/files/files.model';

@Injectable()
export class AdministrationService {
  constructor(private api: ApiService) {
  }

  public getCliRegData(): Observable<any> {
    return this.api.get('/repository/api/v1/cliReg');
  }

  public getPaySerieData(): Observable<any> {
    return this.api.get('/payroll/api/v1/paySerie?noConfid=true');
  }

  public getCliRegFlag(cliReg: number): Observable<any> {
    return this.api.get(`/repository/api/v1/cliReg/${cliReg}/flag`);
  }

  public getPaySerieFlag(paySerieId: number): Observable<any> {
    return this.api.get(`/payroll/api/v1/paySerie/${paySerieId}/flag`);
  }

  public synchronizeContractSearchIndexStatus(): Observable<any> {
    return this.api.get('/elasticquery/api/v1/synchronize/contract/status');
  }

  public synchronizeContractSearchIndex(contractIds: number[]): Observable<any> {
    return this.api.post('/elasticquery/api/v1/synchronize/contract', contractIds);
  }

  public synchronizeEntitySearchIndexStatus(): Observable<any> {
    return this.api.get('/elasticquery/api/v1/synchronize/entity/status');
  }

  public synchronizeEntitySearchIndex(): Observable<any> {
    return this.api.post('/elasticquery/api/v1/synchronize/entity');
  }

  public purgeCache(): Observable<any> {
    return forkJoin(
      this.api.post('/communication/api/v1/admin/cache/purge'),
      this.api.post('/authent/api/v1/admin/cache/purge'),
      this.api.post('/ga/api/v1/admin/cache/purge'),
      this.api.post('/payroll/api/v1/admin/cache/purge')
    );
  }

  public uploadCliCoreImage(clientName: string, image: Image, fileName: string): Observable<FileDescription> {
    return this.api.file.uploadFile(`/static/${clientName}/${fileName}`, image.file, {
      additionalData: {
        width: image.dimensions.width,
        height: image.dimensions.height
      },
      fileName: image.fileName
    });
  }

  public deleteCliCoreImage(clientName: string, fileName: string): Observable<Response> {
    return this.api.file.deleteFile(`/static/${clientName}/${fileName}`);
  }
  public uploadCliRegImage(currentRegulationId: number, image: Image): Observable<any> {
    return this.api.uploadFile(`/repository/api/v1/cliReg/${currentRegulationId}/flag`, image.file, {
      additionalData: {
        width: image.dimensions.width,
        height: image.dimensions.height
      },
      fileName: image.fileName
    });
  }

  public deleteCliRegImage(regulationId: number): Observable<Response> {
    return this.api.delete(`/repository/api/v1/cliReg/${regulationId}/flag`);
  }

  public uploadPaySerieImage(paySerieId: number, image: Image): Observable<any> {
    return this.api.uploadFile(`/payroll/api/v1/paySerie/${paySerieId}/flag`, image.file, {
      additionalData: {
        width: image.dimensions.width,
        height: image.dimensions.height
      },
      fileName: image.fileName
    });
  }

  public deletePaySerieImage(paySerieId: number): Observable<Response> {
    return this.api.delete(`/payroll/api/v1/paySerie/${paySerieId}/flag`);
  }

  public getDescriptors(regId): Observable<any> {
    return this.api.get(`/repository/api/v1/cliReg/${regId}/employeeFormDescriptor`);
  }

  public refreshContractIndexDataByContractIds(contractIds: number[]): Observable<number[]> {
    return this.api.post('/ga/api/v1/admin/contract-index-data/refresh', contractIds);
  }

  public syncPayPeriodContractsByContractIds(contractIds: number[]): Observable<number[]> {
    return this.api.post('/payroll/api/v1/pay-period-contract/sync', contractIds);
  }
}
